import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Grid, Modal, Stack, styled } from '@mui/material';
import { FC } from 'react';
import { Item, WsButton, WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';
export interface DiscardFormProps {
  openDialog: boolean;
  closeDialog(): void;
  handler: (value: boolean) => void;
}
const ModalBox = styled(Box)({
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
const DiscardForm: FC<DiscardFormProps> = ({ openDialog, closeDialog, handler }) => (
  <Modal open={openDialog} onClose={closeDialog}>
    <ModalBox borderRadius={1.5} bgcolor={WsColors.White} p={1} height={130} width={540}>
      <Grid container>
        <Grid direction="row" item>
          <Item>
            <WsTypography variant={WsTypoVariants.TITLE}>
              Are you sure you want to discard current changes if any?
            </WsTypography>
          </Item>
        </Grid>
      </Grid>
      <Stack marginTop={1} spacing={2} justifyContent="flex-end" direction="row">
        <WsButton startIcon={<CancelIcon />} size="medium" variant="outlined" onClick={closeDialog}>
          Cancel
        </WsButton>
        <WsButton size="medium" variant="contained" onClick={() => handler(true)}>
          Confirm
        </WsButton>
      </Stack>
    </ModalBox>
  </Modal>
);

export default DiscardForm;
